import React, {PropTypes} from 'react';

class Filter extends React.Component {
  static propTypes = {
    active: PropTypes.bool,
    children: PropTypes.object,
    filterType: PropTypes.string,
    id: PropTypes.number,
    name: PropTypes.string,
    onClick: PropTypes.func,
    slug: PropTypes.string,
  };

  shouldComponentUpdate(nextProps){
    return this.props.active !== nextProps.active;
  }
  render() {
    return (
      <button className={'filter' + ' ' + this.props.slug + ' ' + (this.props.active ? 'active' : null)}
              onClick={this.props.onClick.bind(this, this.props.id, this.props.filterType)}>
        {this.props.children}
        <span>{this.props.name}</span>
      </button>
    );
  }
}

export default Filter;



/** WEBPACK FOOTER **
 ** ./src/components/nav/Filter.js
 **/